import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "ssrcart",
    initialState: {
        products: [],
        quantity: 0,
        total: 0,
    },
    reducers: {
        addProduct: (state, action) => {
            const product = action.payload

            const countryPrice = product.activeColor.price ?  product.activeColor.price / action.payload.quantity : 0
            const panelTitle = `${product.activeColor.phase ? `${product.activeColor.phase} Phase - `: ""}${product.activeColor.type ? `${product.activeColor.type} - ` : ""}${product.activeColor.voltage ? `${product.activeColor.voltage} - ` : ""}${product.activeColor.kwp ? `${product.activeColor.kwp}KW - ` : ""}${product.activeColor.quantity ? `${product.activeColor.quantity}PCS` : ""}${product.activeColor.system ? `(${product.activeColor.system})` : ""}`
            const normalTitle = `${product.activeColor.type || ""}`
            const fullTitle = `Inverter :${product.activeColor.type} Inverter ${product.activeColor.KW ? `${product.activeColor.KW}KWAC` : ""}${product.activeColor.battery ? ` (${product.activeColor.battery})` : ""}`
            const equipmentTitle = product.activeColor.fullTitle ? product.activeColor.fullTitle : `Equipment: ${product.activeColor.type}`

            const knownCategories = ["Inverter", "Jinko Panel", "Equipment", "Warranty", "Add On", "Others", "Module Bificial Dual Glass", "warranty"]
            const isCustomName = product.activeColor.name && !knownCategories.includes(product.activeColor.name)
            const fallbackTitle = isCustomName ? product.activeColor.name : (normalTitle || product.activeColor.name || "Product")
            const activeTitle = product.activeColor.name === "Inverter" ? fullTitle : product.activeColor.name === "Jinko Panel" ? panelTitle : product.activeColor.name === "Equipment" ? equipmentTitle : fallbackTitle

            const itemCode = product.activeColor.name === "Inverter" ? 
                product.activeColor.type === "Solis" ? `SOLIS-${product.activeColor.KW === "8" ? "2" : product.activeColor.KW === "4" ? "3" : product.activeColor.KW === "15" ? "5" : product.activeColor.KW === "12" ? "4" : "1"}` :
                product.activeColor.type === "Goodwe" ? `DES-${product.activeColor.KW}` :
                product.activeColor.type === "Sunglow" ? `SUNGLOW-${product.activeColor.KW}` :
                product.activeColor.type === "Huawei" ? `HWI-${product.activeColor.KW}` :
                product.activeColor.type === "Solax" ? `SOLAX-HYBRID-${product.activeColor.KW}` :
                product.activeColor.type === "Hoymiles" ? `HYS-LV-1` :
                product.activeColor.type : 
                product.activeColor.name === "Jinko Panel" ?
                    product.activeColor.phase === "Three" ? `T-${product.activeColor.kwp}-${product.activeColor.quantity}PCS-${product.activeColor.voltage}` :
                    product.activeColor.phase === "Single" ? `S-${product.activeColor.kwp}-${product.activeColor.quantity}PCS-${product.activeColor.voltage}` :
                    product.activeColor.name :
                product.activeColor.name === "Module Bificial Dual Glass" ? "BIFICIAL" :
                product.activeColor.name === "warranty" || product.activeColor.name === "Warranty" ?
                    product.activeColor.type === "2 years Warranty (Workmanship)" ? "2 YEARS" :
                    product.activeColor.type === "3 years Warranty (Workmanship)" ? "3 YEARS" :
                    product.activeColor.type === "10 years Product Warranty from Goodwe (Inverter)" ? "10 YEARS" :
                    product.activeColor.type === "12 years Product Warranty from Jinko (PV Panel)" ? "12 YEARS PRODUCT" :
                    product.activeColor.type === "15 years Warranty (Workmanship)" ? "15 YEARS (MANPOWER)" :
                    product.activeColor.type === "15 years Product Warranty from Goodwe (Inverter)" ? "15 YEARS" :
                    product.activeColor.type === "15 years Product Warranty from Jinko (PV Panel)" ? "15 YEARS PRODUCT" :
                    product.activeColor.type === "30 years Performance Warranty from Jinko (PV Panel)" ? "30 YEARS" :
                    product.activeColor.type === "1 + 1 years Leaking Warranty" ? "1+1 YEARS" :
                    product.activeColor.type :
                product.activeColor.name === "Add On" ?
                    product.activeColor.type === "Outstation Fee" ? "OUTSTATION" :
                    product.activeColor.type === "Balast system" ? "BALAST" :
                    product.activeColor.type === "Upgrade inverter" ? "INVERTER" :
                    product.activeColor.type === "Insurance" ? "INSURANCE" :
                    product.activeColor.type === "Maintenance" ? "MAINTENANCE" :
                    product.activeColor.type :
                product.activeColor.name === "Equipment" ?
                    product.activeColor.type :
                product.activeColor.name === "Others" ? 
                    "MISC" :
                product.activeColor.name

            

            state.quantity += 1;
            state.products.push({
                _id: product._id,
                title: isCustomName ? product.activeColor.name : activeTitle.toUpperCase(),
                color: product.activeColor,
                model: product.model,
                price: countryPrice,
                img: product.img,
                type: product.model === undefined ? "WARRANTY" : product.model,
                itemCode: itemCode,
                system: product.activeColor.system,
                amount: action.payload.quantity
            });
            state.total += countryPrice * action.payload.quantity;
        },
        addQuantity: (state, action) => {
            const product = action.payload
            const countryPrice = product.activeColor.price
            const existingProductIndex = state.color.findIndex(
                (item) => `${item.title}-${item.color.name}` === `${action.payload.title}-${action.payload.activeColor.name}`
            );
            state.color[existingProductIndex].quantity =
            state.color[existingProductIndex].quantity +
                action.payload.quantity;
                
            state.total = state.total + (countryPrice * action.payload.quantity);
            if (state.products[existingProductIndex].quantity <= 0){
                state.products.splice(existingProductIndex, 1);
                state.quantity -= 1
            }
        },
        addQuantityIcon: (state, action) => {
            const countryPrice = action.payload.price
            
            const existingProductIndex = state.products.findIndex(
                (item) => item.color && item.color.name === (action.payload.activeColor && action.payload.activeColor.name)
            );

            if (existingProductIndex !== -1) {
                // Convert to numbers to ensure proper arithmetic
                const currentAmount = Number(state.products[existingProductIndex].amount) || 0;
                const quantityChange = Number(action.payload.quantity) || 0;
                const newAmount = currentAmount + quantityChange;
                
                // Update the amount
                state.products[existingProductIndex].amount = newAmount;
                
                // Update total quantity
                state.quantity = state.quantity + quantityChange;
                
                // Update total price
                state.total = state.total + (countryPrice * quantityChange);
                
                // Remove product if amount is 0 or less
                if (newAmount <= 0) {
                    state.products.splice(existingProductIndex, 1);
                    state.quantity -= 1;
                }
            }
        },
        removeProduct: (state, action) => {
            const productIndex = action.payload.index;
            const product = state.products[productIndex];
            
            if (product) {
                // Subtract from totals
                state.quantity -= product.amount;
                state.total -= (product.price * product.amount);
                
                // Remove from array
                state.products.splice(productIndex, 1);
            }
        },
        editOrderSeedData: (state, action) => {
            const payload = action.payload
           
            let totalquantity = 0
            
            payload.products.forEach((product) => {
                totalquantity += product.amount;
        
                state.products.push({
                    _id: product.productId,
                    title: product.code,
                    color: {
                        name: product.code,
                        price: product.price
                    },
                    price: product.price,
                    img: product.img,
                    amount: product.amount,
                    type: product.type,
                    itemCode: product.itemCode
                });
            });


        

            state.quantity = totalquantity
            state.total = payload.amount
        },
        clearCart: (state) => {
            state.products = [];
            state.quantity = 0;
            state.total = 0;
            state.warranty = [];
            state.order = [];
            state.affiliate = [];
          }
    },
});

export const { addProduct, addQuantity, addQuantityIcon, removeProduct, clearCart, editOrderSeedData } = cartSlice.actions;
export default cartSlice.reducer;
